import React, { Component } from 'react';
import PropTypes from "prop-types";
import { connect } from 'react-redux';
import * as AppActions from '../../../redux/app/actions'


class MLLanguageSwitcherContainer extends Component {


    _onchangeLanguage = (e) =>{
   
        var value = e.target.value; 
        this.props.setLanguage(value);
    }

   

    render = () => {
        return (
            <select onChange={this._onchangeLanguage}>
                  {this.props.languages.map((val, i) => <option value={val} key={i} >{val}</option>)}
            </select>
        );
    }

}

const mapStateToProps = state => ({
    language:state.app.language,
    languages:state.app.languages
});

// Any actions to map to the component?
const mapDispatchToProps = {
    setLanguage:AppActions.setLanguage
};
/* Export Component ==================================================================== */
export default connect(mapStateToProps, mapDispatchToProps)(MLLanguageSwitcherContainer);